<template>
  <div
    :class="[
      'hx-form',
      {
        'is-btn': isShowFoldBtn,
      },
    ]"
  >
    <el-form
      ref="form"
      style="width: 100%"
      size="small"
      :model="formModel"
      :label-width="labelWidth"
      :label-position="labelPosition"
      :disabled="disabled"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <el-row>
        <el-col
          v-for="(item, index) in filterFormItemList"
          v-show="
            (!isFoldForm || index < showFieldCount) &&
              (!hideItems.hasOwnProperty(item.uuid) || !hideItems[item.uuid])
          "
          :key="item.key || item.prop || index"
          class="hx-form-item-col"
          :span="item.col || 24 / col"
          :label-position="labelPosition"
        >
          <FormItem
            :form-model="formModel"
            :label-position="labelPosition"
            :label-width="labelWidth"
            :col="col"
            :index="index"
            v-bind="item"
          />
        </el-col>
      </el-row>
      <slot></slot>
    </el-form>
    <div v-if="isShowFoldBtn" class="hx-form__toggle" @click="toggleFormStatus">
      {{ isFoldForm ? '更多' : '收起' }}
    </div>
  </div>
</template>

<script>
import FormItem from './Item'
import { v4 as uuid } from 'uuid'

export default {
  name: 'HxForm',
  components: {
    FormItem,
  },
  provide() {
    return {
      hxForm: this,
    }
  },
  model: {
    prop: 'formModel',
    event: 'updateFormModel',
  },
  props: {
    disabled: Boolean,
    isShowFold: Boolean,
    showMessage: {
      type: Boolean,
      default: false,
    },
    labelWidth: {
      type: String,
      default: '120px',
    },
    labelPosition: {
      type: String,
      default: 'right',
    },
    formItemList: {
      type: Array,
      default: () => [],
    },
    formModel: {
      type: Object,
      default: () => {
        return {}
      },
    },
    col: {
      type: [Number, String],
      default: 4,
    },
    showFieldCount: {
      type: [Number, String],
      default: 8,
    },
  },
  data() {
    return {
      isFoldForm: true, // 是否折叠表单
      items: {},
      formItems: [],
      hideItems: {},
      formValidates: [],
    }
  },
  computed: {
    form() {
      return this.$refs.form
    },
    // 是否显示折叠按钮
    isShowFoldBtn() {
      return (
        this.isShowFold &&
        this.col > 1 &&
        this.filterFormItemList.length > this.showFieldCount
      )
    },
    //  过滤掉隐藏项的列表
    filterFormItemList() {
      return this.formItemList
        .map((item) => ({ ...item, uuid: uuid() }))
        .filter((item) => !item.isHidden)
        .filter((item) =>
          typeof item.hide === 'function' ? item.hide(item) : !item.hide,
        )
        .filter((item) => {
          if (typeof item.show === 'function') {
            return item.show(item)
          }

          return !item.hasOwnProperty('show') || item.show
        })
    },
  },
  watch: {
    formModel: {
      handler(newValue) {
        this.$emit('updateFormModel', newValue)
      },
      deep: true,
    },
    formItemList: {
      handler(val, oldVal) {
        this.hideItems = {}
        this.formItems.forEach((item) => {
          if (
            item.$attrs.type === 'HxTitle' ||
            item.$attrs.type === 'hx-title'
          ) {
            item.$children[0].isUp = true
          }
        })
      },
      deep: true,
    },
    isShowFoldBtn: {
      handler(newValue) {
        if (!newValue) {
          this.isFoldForm = false
        }
      },
      immediate: true,
    },
  },
  created() {
    this.$on('hx.form.addField', (field, name) => {
      if (field) {
        this.items[name] = field
      }
    })

    this.$on('hx.form.removeField', (field, name) => {
      const instance = this.items[name]
      if (Array.isArray(instance)) {
        instance.splice(instance.indexOf(field), 1)
      } else {
        delete this.items[name]
      }
    })

    this.$on('hx.form.addFormValidate', (validate) => {
      if (validate) {
        this.formValidates.push(validate)
      }
    })

    this.$on('hx.form.removeFormValidate', (validate) => {
      this.formValidates.splice(this.formValidates.indexOf(validate), 1)
    })

    this.$on('hx.form.addFormItem', (formItem) => {
      this.formItems.push(formItem)
    })

    this.$on('hx.form.removeFormItem', (formItem) => {
      this.formItems.splice(this.formItems.indexOf(formItem), 1)
    })

    this.$on('hx.form.hxTitleDownUp', (show, uuid) => {
      const hxTitleChild = []
      let isChild = false

      for (let i = 0; i < this.filterFormItemList.length; i++) {
        const item = this.filterFormItemList[i]

        if (isChild) {
          if (item.type === 'HxTitle' || item.type === 'hx-title') {
            break
          }

          hxTitleChild.push(item.uuid)
        }

        if (
          item.uuid === uuid &&
          (item.type === 'HxTitle' || item.type === 'hx-title')
        ) {
          isChild = true
        }
      }

      for (let i = 0; i < hxTitleChild.length; i++) {
        if (!show) {
          this.hideItems[hxTitleChild[i]] = true
        } else {
          this.hideItems[hxTitleChild[i]] = false
        }
      }

      this.hideItems = { ...this.hideItems }
    })
  },
  updated() {},
  methods: {
    validate() {
      const cur = new Promise((resolve, reject) => {
        this.$refs.form.validate((valid, invalidFields) => {
          if (valid) {
            resolve(valid)
            return
          }

          const messages = Object.keys(invalidFields).map(
            (f) => invalidFields[f][0].message,
          )

          reject(new Error(messages[0]))

          if (this.showMessage) {
            this.$message.error(messages[0])
          }

          this.$nextTick(() => {
            this.scrollToErrorView()
          })
        })
      })

      const promiseArr = [cur]

      this.formValidates.forEach((v) => {
        const p = v(false)
        promiseArr.push(p)
      })

      return Promise.all(promiseArr)
    },
    scrollToErrorView() {
      const errors = document.getElementsByClassName('is-error')
      if (errors[0]) {
        errors[0].scrollIntoView({ inline: 'center' })
      }
    },
    toggleFormStatus() {
      this.isFoldForm = !this.isFoldForm
      this.$emit('visible-change', !this.isFoldForm)
    },
  },
}
</script>
